var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseImgMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseImgMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.626068,9.500042 L18.0041143,3.12198814 C18.5912212,2.53488062 18.5912212,1.58299371 18.0041143,0.995970186 C17.4170075,0.408862669 16.4652057,0.408862669 15.8780989,0.995970186 L9.4999685,7.37410804 L3.12183814,0.995886194 C2.53473131,0.408778676 1.58292951,0.408778676 0.995822683,0.995886194 C0.408799847,1.58299371 0.408799847,2.53488062 0.995822683,3.12190415 L7.37395305,9.499958 L0.995822683,15.8780959 C0.408799847,16.4652034 0.408799847,17.4170903 0.995822683,18.0041138 C1.58292951,18.5912213 2.53473131,18.5912213 3.12183814,18.0041138 L9.4999685,11.625976 L15.8780989,18.0041138 C16.4651217,18.5912213 17.4170075,18.5912213 18.0041143,18.0041138 C18.5912212,17.4170063 18.5912212,16.4652034 18.0041143,15.8780959 L11.626068,9.500042 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1---Conversation---Private-Album--Access-granted--See-picture",
    transform: "translate(-14.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCloseImgMsg",
    transform: "translate(14.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -8.000000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 35 0 35 35 0 35"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseImgMsg);
export default __webpack_public_path__ + "static/media/icCloseImgMsg.2e5f01c5bc716cb3d811bb765f5d60fa.svg";
export { ForwardRef as ReactComponent };